import React from "react";
import { Chip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function reportStatusChip(status, errors, onShowError) {
    const theme = useTheme();
    const statusStyles = {
        "Generating": { 
            bg: theme.palette.status.generating.bg, 
            color: theme.palette.status.generating.color, 
            label: theme.palette.status.generating.label 
        },
        "Failed": { 
            bg: theme.palette.status.failed.bg, 
            color: theme.palette.status.failed.color, 
            label: theme.palette.status.failed.label,
            icon: <InfoOutlinedIcon fontSize="small" style={{ marginLeft: 5, color: theme.palette.status.failed.color }} /> 
        },
        "Generated": { 
            bg: theme.palette.status.generated.bg, 
            color: theme.palette.status.generated.color, 
            label: theme.palette.status.generated.label 
        },
        "No Data": { 
            bg: theme.palette.status.noData.bg, 
            color: theme.palette.status.noData.color, 
            label: theme.palette.status.noData.label 
        },
        "Queued": {
            bg: theme.palette.status.queued.bg,
            color: theme.palette.status.queued.color, 
            label: theme.palette.status.queued.label 
        }
    };

    const handleClick = (e) => {
        e.stopPropagation(); 
        if (typeof onShowError === "function") {
            onShowError(errors);
        }
    };

    const { bg, color, label, icon } = statusStyles[status] || statusStyles.completed;

    return (
        <Chip
            label={label}
            variant="filled"
            style={{
                margin: "4px",
                borderRadius: "8px",
                backgroundColor: bg,
                color,
                fontFamily: "Lato",
                fontWeight: "bold",
                borderStyle: "none",
                height: "32px",
                width: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                cursor: status === "Failed" ? "pointer" : "default",
            }}
            icon={status=="Failed" && icon}
            onClick={status === "Failed" && errors?.length > 0 ? handleClick : undefined}
        />
    );
}
